import Model from './Model'

export default class Payment extends Model {
  resource()
  {
    return 'payments'
  }

  async cancel() {
    this.status = 'canceled';
    await this.save();
  }

  capture(amount) {
    this.amount_to_capture = amount;
    return this.save();
  }

  canBeCanceled() {
    return this.can_be_canceled === true
  }

  canBeCaptured() {
    return this.can_be_captured === true
  }

  async refresh()
  {
    const {data} = await this.$http.get(this.endpoint() + '?refresh')
    return new Payment(data.data)
  }
}